<template>
	<div class="pt-0 pt-lg-3">
		<div class="carousel-wrapper"
			:style="screenType !== 'mobile'
				? { display: 'grid',
					gridTemplateColumns: '75px 1fr 75px' }
				: {}"
			>
			<!-- left -->
			<div
				v-if="screenType !== 'mobile'"
				class="d-flex text-light-blue justify-content-start"
			>
				<div
					v-if="reviewsArray.length > 3"
					class="d-flex justify-content-center align-items-center"
				>
					<button
						@click.stop="handleSlideControlsClick('left')"
						class="ts-arrow-left bg-none"
						:disabled="currentCard === 0"
						:class="currentCard > 0 && 'cursor-pointer'"
					></button>
				</div>
			</div>

			<!-- images -->
			<div
				ref="review-carousel"
				class="tf-carousel"
				id="tf-review-carousel"
				:class="
					reviewsArray.length <= cardsDisplayed &&
					'd-flex align-items-center justify-content-center'
				"
			>
				<ul
					ref="review-carousel-ul"
					class="list-unstyled tf-carousel-cards m-0 py-1"
					:class="
						screenType !== 'mobile' &&
						reviewsArray.length > cardsDisplayed &&
						'position-absolute'
					"
					:style="{
						left: carouselLeft,
						transition: `left ${speed}ms ease-in-out`
					}"
				>
					<li
						v-for="(review, review_i) in reviewsArray"
						:key="review_i"
						:style="sliderCardWidth && { width: sliderCardWidth }"
					>
						<Review :cardWidth="sliderCardWidth" :review="review" />
					</li>
				</ul>
				<div
					v-if="screenType === 'mobile'"
					class="d-flex justify-content-between tlink-large-underline link-default"
				>
					<div class="col-6">
						<div class="d-flex w-100 mb-3 cursor-pointer">
							<span @click.stop="handleOpenAllReviewsClick">
								{{ content.liheReviews_seeReviews }} 
								{{ ssrReviewData.reviewsSize }} 
								{{ content.liheReviews_reviews }}
							</span>
						</div>
					</div>
					<div class="col-6">
						<template v-if="isDisplayShowMoreButton">
							<div
								class="d-flex justify-content-end w-100 mb-3 cursor-pointer link-large-underline link-default"
							>
								<span @click.stop="handleSeeMoreClick">
									{{ content.reviews_seeMore }}
								</span>
							</div>
						</template>
						<template v-if="isDisplayShowLessButton">
							<div
								class="d-flex justify-content-end w-100 mb-3 cursor-pointer link-large-underline link-default"
							>
								<span @click.stop="handleSeeLessClick">
									{{ content.reviews_seeLess }}
								</span>
							</div>
						</template>
					</div>
				</div>
			</div>

			<!-- right -->
			<div
				v-if="screenType !== 'mobile'"
				class="d-flex text-light-blue justify-content-end"
			>
				<div
					v-if="reviewsArray.length > 3"
					class="d-flex justify-content-center align-items-center"
				>
					<button
						@click.stop="handleSlideControlsClick('right')"
						class="ts-arrow-right bg-none"
					></button>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import { mapState } from "vuex";
import Review from "@/vue/reviews-translation/components/reviews/review.vue";
import { nextTick } from 'vue';


export default {

	name: "Slider",

	props: {
		reviewsArray: {
			type: Array,
			default: () => {
				return [];
			},
		},
		speed: {
			type: Number,
			default: 250,
		},
	},

	components: {
		Review,
	},

	data() {
		return {
			responsivenessOptions: {
				mobile: 0,
				tablet: 2,
				desktop: 3,
			},
		};
	},

	computed: {
		...mapState([
			"content",
			"ssrReviewData",
			"responseReviewData",
			"liheData",
			"loading",
			"animating",
			"currentCard",
			"cardsDisplayed",
			"sliderCardWidth",
			"ratingsToShow",
			"screenType",
		]),
		carouselLeft() {
			const w = parseInt(this.sliderCardWidth) || 0;
			return `-${this.currentCard * w}px`;
		},

		isDisplayShowMoreButton() {
			if (this.screenType === "mobile") {
				if (
					this.responseReviewData.pageCurrentNum + 1 <
					this.responseReviewData.pageCount
				) {
					return true;
				}
			}
			return false;
		},
		isDisplayShowLessButton() {
			if (this.screenType === "mobile") {
				if (
					(this.responseReviewData.pageCurrentNum + 1 ===
						this.responseReviewData.pageCount &&
						this.responseReviewData.pageCount > 1) ||
					this.responseReviewData.pageCurrentNum !== 0
				) {
					return true;
				}
			}
			return false;
		},
	},

	methods: {
		async handleSeeLessClick() {
			console.log('[Slider] seeLess')
			await this.$store.dispatch("loadReviews", 0);
			window.dispatchEvent(
				new CustomEvent("smoothScrollToSelector", {
					detail: { selector: "#tf-reviews" },
				})
			);
		},

		async handleSeeMoreClick() {
			console.log('[Slider] seeMore')
			const pageNo = this.responseReviewData
				? this.responseReviewData.pageCurrentNum + 1
				: 0;
			await this.$store.dispatch("loadReviews", pageNo);
		},

		isNeedMoreReviews() {
			const slidesPerPage = this.responsivenessOptions[this.screenType];
			const preliminaryNew = this.currentCard + slidesPerPage;
			return preliminaryNew === this.reviewsArray.length;
		},

		getNewCardNo(diff) {
			const preliminaryNewCurrentCardNo = this.currentCard + diff;
			const slidesPerPage = this.responsivenessOptions[this.screenType];
			const arrLength = this.reviewsArray.length;

			if (preliminaryNewCurrentCardNo > arrLength - slidesPerPage) {
				return arrLength - slidesPerPage;
			}
			if (
				preliminaryNewCurrentCardNo < 0 &&
				preliminaryNewCurrentCardNo > -1 * slidesPerPage
			) {
				return 0;
			}
			if (preliminaryNewCurrentCardNo < 0) {
				return arrLength - slidesPerPage;
			}
			return preliminaryNewCurrentCardNo;
		},

		async handleSlideControlsClick(dir) {
			console.log('[Slider] arrow click →', dir);
			if (this.loading || this.animating) return;
			console.log('[Slider] currentCard, cardsDisplayed, totalReviews →',
			this.currentCard, this.cardsDisplayed, this.reviewsArray.length);

			const reviewData = this.responseReviewData;

			const direction = dir === "right" ? "right" : "left";
			const slidesPerPage = this.responsivenessOptions[this.screenType];

			if (direction === "left") {
				const difference = slidesPerPage * -1;
				this.animateToCard(this.getNewCardNo(difference));
			} else if (direction === "right") {
				if (this.isNeedMoreReviews()) {
					if (reviewData.pageCurrentNum + 1 < reviewData.pageCount) {
						this.$store.commit("setLoading", true);
						try {
							await this.$store.dispatch(
								"loadReviews",
								reviewData.pageCurrentNum + 1
							);
						} catch (err) {
							console.error(err);
						}
						this.$store.commit("setLoading", false);
					} else {
						this.animateToCard(0);
						return;
					}
				}
				const difference = slidesPerPage;
				this.animateToCard(this.getNewCardNo(difference));
			}
		},

		animateToCard(cardNo) {
			this.$store.commit("setAnimating", true);
			this.$store.commit("setCurrentCard", cardNo);
			const cardWidthInt = parseInt(this.sliderCardWidth);
			// this.$refs["review-carousel-ul"].style.left = `${
			// 	-1 * cardNo * cardWidthInt
			// }px`;
			setTimeout(() => {
				this.$store.commit("setAnimating", false);
			}, this.speed);
		},

		setCardWidth() {
			const cardsDisplayed = this.responsivenessOptions[this.screenType];
			this.$store.commit("setCardsDisplayed", cardsDisplayed);
			const carouselRect = document
				.querySelector("#tf-review-carousel")
				.getBoundingClientRect();
			const newWidth = carouselRect.width / cardsDisplayed;
			const newWidthStr = `${parseInt(newWidth)}px`;
			if (newWidthStr === this.sliderCardWidth) return;
			this.$store.commit("setSliderCardWidth", newWidthStr);
		},

		resetReviews() {
			this.$store.commit("updateReviewsDataWithResponse", window.reviews);
			this.$store.commit("resetReviewsArray");
			this.$store.commit("addReviewsFromResponse", window.reviews.reviews);
		},

		handleOpenAllReviewsClick() {
			this.$emit("openAllReviews");
		},
	},

	watch: {
		ratingsToShow: {
			handler: function (newVal, oldVal) {
				// Always reset to first card when rating changes
				this.animateToCard(0);
				
				// Only reload if the value actually changed
				if (newVal !== oldVal) {
					if (newVal) {
						// Load filtered reviews for the selected rating
						this.$store.dispatch("loadReviews", 0);
					} else {
						// reset to default reviews
						this.$store.dispatch("resetReviews");
					}
				}
			},
			immediate: false,
		},
	},

	mounted() {
		this.setCardWidth(); // initial width setup

		this.adjustResizeHandler = () => {
		const width = window.innerWidth;
		let type = 'desktop';
		if (width < 768) {
			type = 'mobile';
		} else if (width < 1024) {
			type = 'tablet';
		}

		// Only update if changed
		if (type !== this.screenType) {
			this.$store.commit('setScreenType', type);
		}

		this.setCardWidth(); // always recalculate card width
		this.$store.commit("setCurrentCard", 0); // reset to first card
		// console.log('[Slider] mounted, props→',{screenType:this.screenType,reviewsArray:this.reviewsArray.length,cardsDisplayed:this.cardsDisplayed,sliderCardWidth:this.sliderCardWidth})
		nextTick(()=>{ this.setCardWidth();
			this.adjustHandler=()=>{ if(window.innerWidth!==undefined){this.setCardWidth(); this.$store.commit('setCurrentCard',0)}};
			window.addEventListener('resize',this.adjustHandler);
		});

		const css = `
			.tf-carousel-card { height: 280px; }
			@media (min-width: 768px) {
				.tf-carousel { overflow-x: hidden; overflow-y: visible; position: relative; }
				.tf-carousel-cards { overflow-y: visible !important; display: flex !important; flex-wrap: nowrap; }
				.carousel-wrapper { display: grid !important; grid-template-columns: 75px 1fr 75px !important; }
				.loading-div, .tf-carousel { height: 300px; }
				.slide-btn { width: 48px; height: 48px; }
			}
			button.ts-arrow-left:disabled,
			button.ts-arrow-right:disabled {
				border: 2px solid var(--grey-400);
			}
			button.ts-arrow-left:disabled::before,
			button.ts-arrow-left:disabled::after,
			button.ts-arrow-right:disabled::before,
			button.ts-arrow-right:disabled::after {
				background-color: var(--grey-400);
			}
			`;

		const style = document.createElement('style');
		style.type = 'text/css';
		style.appendChild(document.createTextNode(css));
		document.head.appendChild(style);
    };

    window.addEventListener("resize", this.adjustResizeHandler);
		this.$nextTick(() => {
		this.adjustResizeHandler(); // trigger once initially
		});
 	 },

 	beforeUnmount() {
    	window.removeEventListener("resize", this.adjustResizeHandler);
  	}
};
</script>

<style>
.tf-carousel-card {
	height: 280px;
}
@media (min-width: 768px) {
	.tf-carousel {
		overflow-x: hidden;
		overflow-y: visible;
		position: relative;
	}

	.tf-carousel-cards {
		overflow-y: visible !important;
	}

	.tf-carousel-cards {
		display: flex !important;
		flex-direction: row;
		flex-wrap: nowrap;
	}

	.carousel-wrapper {
		display: grid;
		grid-template-columns: 75px 1fr 75px  !important;
	}

	.loading-div,
	.tf-carousel {
		height: 300px;
	}

	.slide-btn {
		width: 48px;
		height: 48px;
	}
}

button.ts-arrow-left:disabled,
button.ts-arrow-right:disabled {
	border: 2px solid var(--grey-400);
}

button.ts-arrow-left:disabled::before,
button.ts-arrow-left:disabled::after,
button.ts-arrow-right:disabled::before,
.button.ts-arrow-right:disabled::after {
	background-color: var(--grey-400);
}
</style>
